import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import TransactionsInfoList from '@/features/finances/components/Transactions/TransactionsInfo/TransactionsInfoList';
import { cn } from '@/lib/utils';

type Props = {
	apartmentName?: string;
	apartmentId?: string;
	ownerId?: string;
	isMobile?: boolean;
};

const TransactionsInfo: FC<Props> = ({ apartmentName, apartmentId, ownerId, isMobile }) => {
	const { t } = useTranslation();

	return (
		<section className='flex-1 flex flex-col gap-4'>
			<div className='flex gap-2'>
				<h3 className={cn(isMobile && 'text-base')}>
					{t('main.finances.components.transactions.title')}
				</h3>
			</div>
			<TransactionsInfoList
				apartmentName={apartmentName}
				apartmentId={apartmentId}
				ownerId={ownerId}
				isMobile={isMobile}
			/>
		</section>
	);
};

export default TransactionsInfo;
